var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "8px 0" } },
    [
      _c(
        "GmapMap",
        {
          staticStyle: { width: "100%", height: "300px" },
          attrs: { center: _vm.computedCenter, zoom: 15, options: _vm.options },
        },
        [
          _c("GmapInfoWindow", {
            attrs: {
              position: _vm.infoWindowPos,
              opened: _vm.infoWinOpen,
              options: _vm.infoOptions,
            },
            on: {
              closeclick: function ($event) {
                _vm.infoWinOpen = false
              },
            },
          }),
          _vm._l(_vm.computedRecords, function (m, i) {
            return _c("GmapMarker", {
              key: i,
              attrs: {
                position: m.position,
                clickable: true,
                draggable: false,
              },
              on: {
                click: function ($event) {
                  return _vm.toggleInfoWindow(m, i)
                },
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }